import { render, staticRenderFns } from "./BuchungGruppierungskonten.vue?vue&type=template&id=53e8e866&"
import script from "./BuchungGruppierungskonten.vue?vue&type=script&lang=js&"
export * from "./BuchungGruppierungskonten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports